import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { Permission } from '@server/permissions';
import { usePermissions } from './usePermissions';

const useCheckPermissionsForCurrentCrmOrg = (permissionArray: Permission[]) => {
  const { checkPermissionsForOrg } = usePermissions();

  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);

  return checkPermissionsForOrg(permissionArray, crmOrgId ?? '');
};

export default useCheckPermissionsForCurrentCrmOrg;
